export const CACHE_KEY_LIST_USER = 'users';
export const CACHE_KEY_LIST_OFFICERS_USER = 'officers-users';
export const CACHE_KEY_USER = 'users-one';
export const ROUTE_PATH_USER = '/admin/users';
export const ROUTE_PATH_OFFICERS_USER = '/admin/officers';
export const SECURITY_KEY_OFFICER = 'OFFICIAL';
export const TRANSLATION_PREFIX_USER = 'user';
export const TRANSLATION_PREFIX_OFFICERS_USER = 'user.func';
export const SECURITY_KEY_USER = 'USER';

export * from './user.columns';
export * from './user.filters.js';
export * from './user.form';
export * from './user.status';

export const USER_FUNCTIONARY_TYPE_APPEARANCE = {
  HISTORIAN: { color: 'orange' },
  FUNCTIONARY: { color: 'red' },
  FUNCTIONARY_ORGANIZATION: { color: 'green' },
  NOTARY: { color: 'blue' },
  ONAT_USER: { color: 'blue' },
  NOTARY_DPJ: { color: 'grey' },
  COMMERCIAL_REGISTER: { color: 'olive' }
};



